import React, { useState, useEffect } from 'react';
import { getBusinessSettings, updateBusinessSettings } from '../../api/adminApi';

function SettingsPage() {
  const [settings, setSettings] = useState({
    company_name: '',
    about_text: '',
    phone: '',
    facebook_url: '',
    instagram_url: '',
    fragrance_description: '',
    footer_text: ''
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const data = await getBusinessSettings();
      setSettings({
        company_name: data.company_name || '',
        about_text: data.about_text || '',
        phone: data.phone || '',
        facebook_url: data.facebook_url || '',
        instagram_url: data.instagram_url || '',
        fragrance_description: data.fragrance_description || '',
        footer_text: data.footer_text || ''
      });
    } catch (err) {
      console.error('Error fetching settings:', err);
      alert('Erreur de chargement des paramètres');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccessMessage('');

    try {
      await updateBusinessSettings(settings);
      setSuccessMessage('✅ Paramètres mis à jour avec succès !');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Error updating settings:', err);
      alert('Erreur lors de la mise à jour des paramètres');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <div>Chargement...</div>;
  }

  return (
    <div>
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '0.5rem' }}>Paramètres du Site</h1>
        <p style={{ color: '#7f8c8d', fontSize: '0.95rem' }}>
          Gérez les informations de votre entreprise et les contenus affichés sur le site public
        </p>
      </div>

      {successMessage && (
        <div style={{
          padding: '1rem',
          backgroundColor: '#d4edda',
          color: '#155724',
          borderRadius: '4px',
          marginBottom: '1.5rem',
          border: '1px solid #c3e6cb'
        }}>
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '2rem'
        }}>
          {/* Company Info Section */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#2c3e50',
              fontSize: '1.3rem',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #9c6f44'
            }}>
              Informations de l'Entreprise
            </h2>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                Nom de l'Entreprise *
              </label>
              <input
                type="text"
                name="company_name"
                value={settings.company_name}
                onChange={handleInputChange}
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Affiché dans le header et le footer du site
              </small>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                Texte "À Propos"
              </label>
              <textarea
                name="about_text"
                value={settings.about_text}
                onChange={handleInputChange}
                rows="4"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  fontFamily: 'inherit'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Description de votre entreprise affichée sur la page d'accueil
              </small>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                Description des Senteurs
              </label>
              <textarea
                name="fragrance_description"
                value={settings.fragrance_description}
                onChange={handleInputChange}
                rows="2"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  fontFamily: 'inherit'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Texte affiché au-dessus de la liste des senteurs
              </small>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                Texte du Footer
              </label>
              <input
                type="text"
                name="footer_text"
                value={settings.footer_text}
                onChange={handleInputChange}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Texte affiché en bas de page (ex: "Tous droits réservés")
              </small>
            </div>
          </div>

          {/* Contact Info Section */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#2c3e50',
              fontSize: '1.3rem',
              marginBottom: '1.5rem',
              paddingBottom: '0.5rem',
              borderBottom: '2px solid #9c6f44'
            }}>
              Coordonnées
            </h2>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                Téléphone
              </label>
              <input
                type="tel"
                name="phone"
                value={settings.phone}
                onChange={handleInputChange}
                placeholder="0612345678"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Numéro affiché dans la section contact
              </small>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                URL Facebook
              </label>
              <input
                type="url"
                name="facebook_url"
                value={settings.facebook_url}
                onChange={handleInputChange}
                placeholder="https://facebook.com/..."
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Lien vers votre page Facebook
              </small>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#2c3e50' }}>
                URL Instagram
              </label>
              <input
                type="url"
                name="instagram_url"
                value={settings.instagram_url}
                onChange={handleInputChange}
                placeholder="https://instagram.com/..."
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem'
                }}
              />
              <small style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                Lien vers votre compte Instagram
              </small>
            </div>
          </div>

          {/* Submit Button */}
          <div style={{
            borderTop: '1px solid #dee2e6',
            paddingTop: '1.5rem',
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
            <button
              type="submit"
              disabled={submitting}
              style={{
                padding: '0.75rem 2rem',
                backgroundColor: '#9c6f44',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: submitting ? 'not-allowed' : 'pointer',
                fontWeight: 600,
                fontSize: '1rem',
                opacity: submitting ? 0.7 : 1,
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => !submitting && (e.target.style.backgroundColor = '#8a5f38')}
              onMouseLeave={(e) => !submitting && (e.target.style.backgroundColor = '#9c6f44')}
            >
              {submitting ? 'Enregistrement...' : '💾 Enregistrer les Modifications'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SettingsPage;
